export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'I was terrified of spinal surgery. I always feared a wrong move would leave me bedridden. After day 5 with 360 SPINAL SHIELD™, I understood exactly how to decompress my lumbar spine. By week 4, I was back to my morning runs with zero fear. This system is a complete game-changer.',
    name: 'Marcus T.',
    location: 'New York · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/ef84aa00-709f-456f-afe3-7c781c734823.jpg',
  },
  {
    quote:
      'I managed sciatica for months, frustrated because it kept coming back. The 360° method actually works. The focus on pelvic unlocking and neural reset made the difference. I am now back to my professional routine thanks to SIGMA SMART™.',
    name: 'Sofia L.',
    location: 'Toronto · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/549edc20-6760-465c-89a8-3b55e3eebd82.jpg',
  },
  {
    quote:
      'I thought I needed expensive physical therapy forever. 360° proved me wrong. The visual method makes the stages of spinal healing so clear. I felt confident from DAY ONE. I recommend this to anyone struggling with back stiffness.',
    name: 'David P.',
    location: 'Melbourne · Australia',
    flag: '🇦🇺',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/abeba4cf-9b76-477a-a5c3-062162635fc6.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'The tracking sheets live on my fridge now. I know exactly how to adjust my sitting position at work. Six weeks in and the constant ache is gone. SIGMA SMART™ delivered.',
    name: 'James R.',
    location: 'Toronto · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/3efc2349-4a3b-468e-81ac-953c40807e03.jpg',
  },
  {
    quote:
      'The S.O.S. Rescue Protocol did it in two days. I had tried random YouTube stretches for six months and always felt worse. Seeing the mechanics explained visually finally made sense.',
    name: 'Emma T.',
    location: 'London · UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/006283bb-3547-4bf4-a52d-f0c4cd279c9f.jpg',
  },
  {
    quote:
      'The 30-day roadmap is what kept me consistent. Twenty minutes a day, no wondering whether I was doing too much. Week 4 I was back to playing with my kids without pain.',
    name: 'Luis M.',
    location: 'California · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/b5b63af5-e9fe-4502-8311-a5389f278c65.jpg',
  },
];
